/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="remove_card">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">
              {{ cvCardTitle }}
            </h4>
          </template>
          <template>
            <p v-if="!propOpenedInModal">
              {{ cvCardSubHeader }}
            </p>
            <ValidationObserver ref="subsPlanForm">
              <form action="#">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="subs_plan_id">{{cvSubsPlanId}} <small>(Only Alphabets, Numbers & Dash is Allowed)</small></label>
                    <ValidationProvider
                      name="Plan Id"
                      rules="required|max:50|regex:^([a-zA-Z0-9-])*$"
                      v-slot="{ errors }">
                      <input
                        id="subs_plan_id"
                        v-model="vmSubscriptionPlanFormData.subs_plan_id"
                        type="text"
                        class="form-control"
                        required
                      />
                      <span class="text-danger"> {{ errors[0] }}</span>
                      <small>
                        <i class="information-color">Plan Ids should be in captial case only. Begin with the Module Name like TESTSERIES, GPATHS, GIDEPREP, GIDEPRENEUR etc. See example below.</i><br>
                        Suggestions: <span v-for="(suggestion, index) of sub_plan_id_suggestion_list" :key="updateSubsPlanId+index">
                          <b-badge class="border mr-2 mb-2 font-weight-normal" variant="none">
                            <span class="pointer" @click="doCopy(suggestion.name)">{{ suggestion.name }}</span>
                          </b-badge>
                        </span>
                      </small>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label>Subscription Domain Name</label>
                    <ValidationProvider
                      name="subscription domain"
                      rules="required|min:2"
                      v-slot="{ errors }">
                      <input
                        v-model="vmSubscriptionPlanFormData.subs_plan_domain_name"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="information-color"><small>Ex: www.CLATPerfect.com, www.Gide.ai</small></span>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label for="subs_product_name">Product Name Category</label>
                    <ValidationProvider
                      name="Product Name"
                      rules="required"
                      v-slot="{ errors }">
                      <multiselect
                        v-model="selectedProduct"
                        :options="productOptions"
                        placeholder="Search & Select Product Name"
                        track-by="key"
                        label="text"
                        :searchable="true"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        @input="handleProductSelect">
                        <span slot="noResult">No products found</span>
                      </multiselect>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <!-- Revenue source filter -->
                  <b-col class="col-md-12 mb-3">
                    <label for="subs_revenue_src">{{cvSubsRevenueSrc}}</label>
                    <select v-model="vmSubscriptionPlanFormData.revenue_src" class="form-control">
                      <option v-for="(src, index) of revenueSrcList" :key="(index+1)" :value="src">
                        {{src}}
                      </option>
                    </select>
                  </b-col><!-- Revenue source filter -->

                  <div class="col-md-12 mb-3">
                    <label for="subs_plan_name">{{cvSubsPlanNameLabel}}</label>
                    <ValidationProvider
                      name="Plan Name"
                      rules="required|max:50"
                      v-slot="{ errors }">
                      <input
                        id="subs_plan_name"
                        v-model="vmSubscriptionPlanFormData.subs_plan_name"
                        type="text"
                        class="form-control"
                        required
                      />
                      <small>
                        <i class="information-color">Note: Plan Name should be less than 50 chars</i><br>
                        Suggestions: <span v-for="(suggestion, index) of sub_plan_name_suggestion_list" :key="index">
                          <b-badge
                            class="border mr-2 mb-2 font-weight-normal"
                            variant="none"
                          >
                            <span class="information-color">{{ suggestion.name }}</span>
                          </b-badge>
                        </span>
                      </small>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanModuleTypeLabel}}</label>
                    <ValidationProvider
                      name="Plan Applicable for"
                      rules="required"
                      v-slot="{ errors }">
                      <multiselect
                        v-model="vmSelectedSubsModType"
                        :options="subscriptionPlanModuleTypeObjList"
                        :placeholder="cvSelectBoxText + cvSubsPlanModuleTypeLabel"
                        :tag-placeholder="cvSelectBoxText + cvSubsPlanModuleTypeLabel"
                        label="module_name"
                        track-by="module_abbr"
                        required>
                      </multiselect>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanIntervalLabel}}</label>
                    <ValidationProvider
                      name="Plan Interval"
                      rules="required"
                      v-slot="{ errors }">
                      <multiselect
                        v-model="vmSelectedSubsInterval"
                        :options="subscriptionPlanTypeObjList"
                        :placeholder="cvSelectBoxText + cvSubsPlanIntervalLabel"
                        :tag-placeholder="cvSelectBoxText + cvSubsPlanIntervalLabel"
                        label="spi_name"
                        track-by="id">
                      </multiselect>
                      <span class="text-danger"> {{ errors[0] }} </span>
                      <span class="information-color"><small>Note: Recurrent yealy/monthly or a single use plan with validy for the interval count (1 month or 1 year, 2 months or 2 year)</small></span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="subs_plan_interval_count">{{cvSubsPlanIntervalCountLabel}}</label>
                    <ValidationProvider
                      name="Plan Interval Count"
                      rules="required|max:1"
                      v-slot="{ errors }">
                      <input
                        id="subs_plan_interval_count"
                        v-model="vmSubscriptionPlanFormData.subs_plan_interval_count"
                        type="number"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                      <span class="information-color"><small>Note: Put a numeric value to indicate the duration of the plan. Example 1 or 2 or 3</small></span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanModulesLabel}}</label>
                    <br />
                    <span
                      v-for="(module) in vmModuleList"
                      :key="module.id">
                      <b-badge
                        style="cursor:pointer;"
                        :style="(selectedModuleObjList && selectedModuleObjList[module.id]) ? setModuleChipStyle(true) : setModuleChipStyle(false)"
                        class="border mr-2 mb-2 font-weight-normal"
                        variant="none"
                        @click="selectModule(module)">
                        <span>{{ module.mod_name }}</span>
                      </b-badge>
                    </span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanTypeLabel}}</label> <b class="text-capitalize">({{ vmSubscriptionPlanFormData.subs_plan_type }})</b>
                    <select
                      v-model="vmSubscriptionPlanFormData.subs_plan_type"
                      class="form-control"
                      type="text"
                    >
                    <option v-for="(value, index) in PlanType" :key="index">{{index}}</option>
                    </select>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="sub_plan_module_obj_id">{{cvSubsPlanModObjId}}</label>&nbsp;&nbsp;<i class="fa fa-info-circle mr-2 primary-color pointer" title="For Event & Activity based plans, this is generated dynamically. For products like GPaths, Counselling it has to be set manually"></i>
                    <input
                      id="sub_plan_module_obj_id"
                      v-model="vmSubscriptionPlanFormData.sub_plan_module_obj_id"
                      type="text"
                      class="form-control"
                    />
                    <span class="information-color"><small>Note: For Event & Activity based plans, this is generated dynamically. For products like GPaths, Counselling it has to be set manually</small></span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanCurrencyLabel}}</label>
                    <ValidationProvider
                      name="Plan Currency"
                      rules="required"
                      v-slot="{ errors }">
                      <multiselect
                        v-model="vmSelectedSubsPlanCurrMixin"
                        :tag-placeholder="cvSelectBoxText + cvSubsPlanCurrencyLabel"
                        :placeholder="cvSelectBoxText + cvSubsPlanCurrencyLabel"
                        :searchable="true"
                        label="currency_name"
                        track-by="id"
                        :options="cvCurrencyOptions"></multiselect>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanPriceLabel}}</label>
                    <ValidationProvider
                      name="Plan Price"
                      rules="required|numeric"
                      v-slot="{ errors }">
                      <input
                        v-model="vmSubscriptionPlanFormData.subs_plan_price"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanPriceGidePlusLabel}}</label>
                    <ValidationProvider
                      name="Plan Price Gide Plus"
                      rules="required|numeric"
                      v-slot="{ errors }">
                      <input
                        v-model="vmSubscriptionPlanFormData.subs_plan_price_gideplus"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label>Plan Price In USD (For other countries) If Applicable (0 for N/A)</label>
                    <ValidationProvider
                      name="Plan Price In USD"
                      rules="numeric"
                      v-slot="{ errors }">
                      <input
                        v-model="vmSubscriptionPlanFormData.subs_plan_usd_price"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Gide Plus Price In USD (For other countries) If Applicable</label>
                    <ValidationProvider
                      name="Plan Price for Gide Plus In USD"
                      rules="numeric"
                      v-slot="{ errors }">
                      <input
                        v-model="vmSubscriptionPlanFormData.subs_plan_usd_price_gideplus"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3" :key="update">
                    <label>{{cvSubsPlanDescLabel}}</label>
                    <ValidationProvider
                      name="Plan Desc"
                      rules="max:4096"
                      v-slot="{ errors }">
                      <b-form-textarea
                        v-model="vmSubscriptionPlanFormData.subs_plan_desc"
                        :placeholder="cvCourDescLabel"
                        rows="5"
                        max-rows="10"
                        required></b-form-textarea>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label>{{cvSubsPlanRulesLabel}}</label>
                    <textarea placeholder='Sample JSON: { "pdt_id": "APPGPATHPRODUCTID" } OR { "pdt_id": "APPGPATHPRODUCTIDJEE" } OR { "pdt_id": "APPGPATHPRODUCTIDNEET" }. Type here ....' v-model="vmSubscriptionPlanFormData.subs_plan_rules" type="json" @input="formatJSON" class="form-control textarea" id="json"></textarea>
                    <span class="primary-color" v-if="invalidJSONMsg">{{invalidJSONMsg}}</span>
                    <div class="information-color">
                      <p>
                        Examples: Sample rules respective to the plans. Modify them as per the plan.
                      </p>

                      <section>
                        <b>Examples for TESTSERIES:</b>
                        <ol>
                          <li>
                            {{ extestSeriesSAT }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(extestSeriesSAT)"></i>
                          </li>
                          <li>
                            {{ extestSeriesCLAT }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(extestSeriesCLAT)"></i>
                          </li>
                        </ol>
                      </section>

                      <section>
                        <b>Examples for GPATHS:</b>
                        <ol>
                          <li>
                            {{ exgpaths1 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgpaths1)"></i>
                          </li>
                          <li>
                            {{ exgpaths2 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgpaths2)"></i>
                          </li>
                          <li>
                            {{ exgpaths3 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgpaths3)"></i>
                          </li>
                          <li>
                            {{ exgpaths4 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgpaths4)"></i>
                          </li>
                        </ol>
                      </section>

                      <section>
                        <b>Examples for GIDEPRENEUR:</b>
                        <ol style="overflow-wrap: anywhere;">
                          <li>
                            {{ exgidepreneur1 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgidepreneur1)"></i>
                          </li>
                          <li>
                            {{ exgidepreneur2 }}
                            &nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy" @click="doCopy(exgidepreneur2)"></i>
                          </li>
                        </ol>
                      </section>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                    <b-spinner label="Spinning">
                    </b-spinner>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="subscriptionPlanAdd()">
                    {{ cvSubmitBtn }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan"
import ApiResponse from "../../../Utils/apiResponse.js"
import Multiselect from "vue-multiselect"
import CountryMixin from "../../../Utils/Mixins/country"
import { ValidationProvider } from "vee-validate"
import { modules } from "../../../FackApi/api/modules"
import PlanType from "../../../FackApi/json/planType.json"
import subsRuleCounselling from "../../../FackApi/json/subscription_rules_counselling.json"
import userPermission from "../../../Utils/user_permission.js"
import Utility from "../../../Utils/utility.js"
import productName from "../../../FackApi/json/productName.json"

export default {
  name: "SubscriptionPlanAdd",
  props: {
    propModuleOldSubsPlanId: {
      type: String,
      default: null
    },
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propModuleName: {
      default: null
    },
    propModuleObjId: {
      default: null
    },
    propModulePlanName: {
      default: null
    },
    propModuleDesc: {
      default: null
    },
    propRoleId: {
      default: null
    },
    planExists: {
      type: Object,
      default: null
    },
    propSubscriptionPlandDuplicateObj: {
      type: Object,
      default: function () {
        return {
          "subs_plan_id": "",
          "subs_plan_name": "",
          "subs_plan_interval": "",
          "subs_plan_modules": "",
          "subs_plan_currency": "",
          "subs_plan_price": ""
        }
      }
    }
  },
  components: {
    Multiselect,
    ValidationProvider
  },
  data () {
    return {
      apiName: "subscriptionPlan_add",
      cvCardTitle: "Add subscription Plan",
      cvCardSubHeader: "Add subscription Plan",
      cvSubmitBtn: "Add",
      cvSelectBoxText: "Select ",
      cvSubsPlanId: "Plan Id",
      cvSubsPlanNameLabel: "Plan Name",
      cvSubsPlanIntervalLabel: "Plan Interval",
      cvSubsPlanTypeLabel: "Plan Type",
      cvSubsPlanModObjId: "Plan Module Object Id",
      cvSubsPlanIntervalCountLabel: "Plan Interval Count",
      cvSubsPlanModulesLabel: "Plan Modules",
      cvSubsPlanCurrencyLabel: "Plan Currency",
      cvSubsPlanRulesLabel: "Subscription Plan Rules",
      cvSubsPlanPriceLabel: "Plan Price",
      cvSubsPlanPriceGidePlusLabel: "Plan Price For Gide Plus ",
      cvSubsPlanModuleTypeLabel: "Plan Applicable for",
      cvSubsPlanDescLabel: "Plan Description",
      cvCourDescLabel: "Write Your Description",
      cvSubsRevenueSrc: "Revenue Types",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "subscription Plan",
      vmSubscriptionPlanFormData: Object.assign({}, this.initFormData()),
      vmSubscriptionPlanDesc: null,
      vmSubscriptionPlanType: null,
      subscriptionPlanTypeObjList: [],
      selectedModuleObjList: {},
      showRevenue: false,

      // TESTSERIES
      extestSeriesSAT: '{"batch":"1,2,3","exam_name":"SAT","interest_id":"TESTSERIES_SAT_MOCK"}',
      extestSeriesCLAT: '{"batch":"1","exam_name":"CLAT","interest_id":"TESTSERIES_CLAT_MOCK"}',
      extestSeriesCUET: '{"batch":"2","exam_name":"CUET","interest_id":"TESTSERIES_CUET_MOCK"}',

      // GPATHS
      exgpaths1: '{"pdt_id": "APPGPATHPRODUCTID", "allowCounselingSession": 1}',
      exgpaths2: '{"pdt_id": "APPGPATHPRODUCTID"}',
      exgpaths3: '{"pdt_id":"APPGPATHPRODUCTID08"}',
      exgpaths4: '{"pdt_id":"APPGPATHPRODUCTIDJEE"}',
      exgpaths5: '{"pdt_id":"APPGPATHPRODUCTIDNEET"}',
      exgpaths6: '{"pdt_id":"APPGPATHPRODUCTIDGRAD"}',

      // GIDEPRENEUR
      exgidepreneur1: '{"limit":25,"commission":12,"mkt_support":0,"product_name":"SAASORGGPATH","affiliated_module":"gpaths","domain_whitelabel":1}',
      exgidepreneur2: '{"limit":15,"commission":10,"mkt_support":0,"product_name":"SAASORGGPATH","affiliated_module":"gpaths","domain_whitelabel":0}',

      subscriptionPlanModuleTypeObjList: [
        {
          "module_abbr": "STUDENT",
          "module_name": "Student",
          "module_role_id": "USERROLE11114"
        },
        {
          "module_abbr": "UNIV",
          "module_name": "University",
          "module_role_id": "USERROLE11115"
        },
        {
          "module_abbr": "ORG",
          "module_name": "Organization",
          "module_role_id": "USERROLE11116"
        }
      ],
      revenueSrcList: [
        "B2C",
        "B2B",
        "B2B2C",
        "B2B2A", // Affilate Codes Added by Counselors
        "B2G" // GIDEPreneur
      ],
      vmSelectedSubsInterval: {},
      vmSelectedSubsPlanCurr: {},
      vmSelectedSubsModType: {},
      vmModuleList: [],
      update: 0,
      updateSubsPlanId: 0,
      PlanType: PlanType,
      subsRuleCounselling: subsRuleCounselling,
      invalidJSONMsg: null,
      sub_plan_id_suggestion_list: [ { name: "GPATHS-EVENT-4999" }, { name: "TESTSERIES-SAT-CLASS-100000" }, { name: "TESTSERIES-CLAT-MOCKTEST-9999" }, { name: "GIDEPRENEUR-pkg-100k" }, { name: "GIDEBASIC-6999" }, { name: "GIDEPLUS-SCH-MOS-6999" }, { name: "GPATHS-BEYONDNEET-899" } ],
      sub_plan_name_suggestion_list: [ { name: "GIDEPrep-TestSeries: practice test series for classrooms (CLAT)" }, { name: "TestSeries: SAT Practice & 10 Mock Tests" }, { name: "GIDE PLUS" }, { name: "GIDEPreneur Enterprise Package - 100K" }, { name: "GPaths-BeyondNEET" }, { name: "GPaths - Futuristic Career Assessment | BLOOMING" }, { name: "GPaths - Dharav High School" } ],
      doCopy: Utility.doCopy,
      selectedProduct: null,
      productOptions: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mixins: [ CountryMixin ],
  async mounted () {
    this.initialiseData()
    await this.loadProductOptions()

    if (this.propSubscriptionPlandDuplicateObj && this.propSubscriptionPlandDuplicateObj.subs_plan_id) {
      this.vmSubscriptionPlanFormData = {
        ...this.propSubscriptionPlandDuplicateObj,
        subs_plan_id: this.propSubscriptionPlandDuplicateObj.subs_plan_id.replace(/copy$/i, "") + "-copy",
        subs_plan_name: this.propSubscriptionPlandDuplicateObj.subs_plan_name.replace(/copy$/i, "") + "-copy",
        gide_product_name: this.propSubscriptionPlandDuplicateObj.gide_product_name || ""
      }

      if (this.vmSubscriptionPlanFormData.gide_product_name) {
        this.selectedProduct = this.productOptions.find(o => o.key === this.vmSubscriptionPlanFormData.gide_product_name) || null
      }
    }

    if (this.planExists) {
      this.vmSubscriptionPlanFormData = Object.assign({}, this.planExists)
      const planType = Object.entries(this.PlanType).find(([, type]) => {
        return type == this.vmSubscriptionPlanFormData.subs_plan_type
      })[0]
      this.vmSubscriptionPlanFormData.subs_plan_type = planType

      if (this.vmSubscriptionPlanFormData.gide_product_name) {
        this.selectedProduct = this.productOptions.find(o => o.key === this.vmSubscriptionPlanFormData.gide_product_name) || null
      }
    }

    this.vmSubscriptionPlanFormData.sub_plan_module_obj_id = this.propModuleObjId

    this.subscriptionPlanTypeList()
    this.moduleList()
  },
  methods: {
    /**
     * load Product Options
     */
    loadProductOptions () {
      if (productName) {
        this.productOptions = Object.keys(productName).map(key => {
          return {
            key: key,
            text: productName[key]
          }
        })
      }
    },
    /**
     * handleProductSelect
     */
    async handleProductSelect (selectedOption) {
      this.selectedProduct = selectedOption
      this.vmSubscriptionPlanFormData.gide_product_name = selectedOption ? selectedOption.key : ""
    },
    /**
     * formatJSON
     */
    formatJSON (event, unformattedJSON = null) {
      try {
        if (!unformattedJSON) {
          unformattedJSON = document.getElementById("json").value
        }
        let obj = JSON.parse(unformattedJSON)
        if (obj) {
          this.invalidJSONMsg = false
        }
        let formattedJSON = JSON.stringify(obj, undefined, 2)
        this.vmSubscriptionPlanFormData.subs_plan_rules = formattedJSON
      }
      catch (err) {
        this.invalidJSONMsg = "Invalid JSON"
      }
    },
    /**
     * initFormData
     */
    initFormData () {
      this.vmSelectedSubsInterval = {}
      this.vmSelectedSubsPlanCurr = {}
      this.selectedModuleObjList = {}
      this.selectedProduct = null
      return {
        "subs_plan_name": "",
        "subs_plan_interval": "",
        "subs_plan_modules": "",
        "subs_plan_currency": "",
        "subs_plan_price": "",
        "subs_plan_type": {},
        "subs_plan_domain_name": "",
        "gide_product_name": ""
      }
    },
    /**
     * initialiseData
     */
    initialiseData () {
      if (this.planExists) {
        this.vmSubscriptionPlanFormData = this.planExists
        this.curSelectedCurrency(this.planExists.subs_plan_currency)
      }
    },
    /*
     * module_list
     */
    async moduleList () {
      let resp = await modules.moduleList(this)
      if (!resp.resp_status) {
        return false
      }
      this.vmModuleList = resp.resp_data.data

      if (this.propModuleName) {
        const findModIndex = this.vmModuleList.findIndex(mod => mod.mod_name === this.propModuleName)

        if (findModIndex >= 0) {
          this.$set(this.selectedModuleObjList, this.vmModuleList[findModIndex].id, this.vmModuleList[findModIndex])
        }

        if (this.propModulePlanName) {
          this.vmSubscriptionPlanFormData.subs_plan_name = this.propModulePlanName
        }

        if (this.propModuleDesc) {
          this.vmSubscriptionPlanFormData.subs_plan_desc = this.propModuleDesc
          this.update += 1
        }

        if (this.propRoleId) {
          const findIndex = this.subscriptionPlanModuleTypeObjList.findIndex(ele => ele.module_role_id === this.propRoleId)
          if (findIndex >= 0) {
            this.vmSelectedSubsModType = this.subscriptionPlanModuleTypeObjList[findIndex]
          }
        }
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSubscriptionPlanFormData) {
          if (!this.vmSubscriptionPlanFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * subscriptionPlanTypeList
     */
    async subscriptionPlanTypeList () {
      try {
        let subscriptionPlanTypeListResp = await SubscriptionPlans.subscriptionPlanTypeList(this)
        if (subscriptionPlanTypeListResp.resp_status) {
          this.subscriptionPlanTypeObjList = subscriptionPlanTypeListResp.resp_data.data
          const planInterval = this.subscriptionPlanTypeObjList.find((e) => {
            return e.spi_name == this.vmSubscriptionPlanFormData.subs_plan_interval
          })
          this.vmSelectedSubsInterval = planInterval
        }
      }
      catch (err) {
        console.log("Exception occurred at subscriptionPlanTypeList() and Exception:", err.message)
      }
    },
    /**
     * subscriptionPlanAdd
     */
    async subscriptionPlanAdd () {
      let valid = await this.$refs.subsPlanForm.validate()

      if (!valid) {
        return
      }

      try {
        // If B2C, B2B etc not included then include
        this.vmSubscriptionPlanFormData.revenue_src = this.vmSubscriptionPlanFormData.revenue_src ? this.vmSubscriptionPlanFormData.revenue_src : "B2C"
        this.vmSubscriptionPlanFormData.subs_plan_id = this.vmSubscriptionPlanFormData.subs_plan_id && this.vmSubscriptionPlanFormData.subs_plan_id.includes(this.vmSubscriptionPlanFormData.revenue_src) ? this.vmSubscriptionPlanFormData.subs_plan_id : `${this.vmSubscriptionPlanFormData.subs_plan_id}-${this.vmSubscriptionPlanFormData.revenue_src}`

        this.cvLoadingStatus = true
        // Extract value of subscription plan interval object
        if (this.vmSelectedSubsInterval && Object.keys(this.vmSelectedSubsInterval).length > 0) {
          this.vmSubscriptionPlanFormData.subs_plan_interval = this.vmSelectedSubsInterval.spi_name
        }

        if (this.vmSelectedSubsPlanCurrMixin && Object.keys(this.vmSelectedSubsPlanCurrMixin).length > 0) {
          this.vmSubscriptionPlanFormData.subs_plan_currency = JSON.stringify(this.vmSelectedSubsPlanCurrMixin)
        }

        if (this.selectedModuleObjList && Object.keys(this.selectedModuleObjList).length > 0) {
          this.vmSubscriptionPlanFormData.subs_plan_modules = JSON.stringify(this.selectedModuleObjList)
        }

        if (this.propModuleName == "counselling") {
          this.vmSubscriptionPlanFormData.subs_plan_rules = JSON.stringify(this.subsRuleCounselling)
        }

        if (this.vmSelectedSubsModType && Object.keys(this.vmSelectedSubsModType).length > 0) {
          this.vmSubscriptionPlanFormData.subs_plan_allowed_role = this.vmSelectedSubsModType.module_role_id
        }

        if (this.propModuleObjId) {
          this.vmSubscriptionPlanFormData.sub_plan_module_obj_id = this.propModuleObjId
        }

        if (this.propModuleOldSubsPlanId) {
          this.vmSubscriptionPlanFormData.old_subs_plan_id = this.propModuleOldSubsPlanId
        }

        if (this.vmSubscriptionPlanFormData.subs_plan_type) {
          this.vmSubscriptionPlanFormData.subs_plan_type = this.PlanType[this.vmSubscriptionPlanFormData.subs_plan_type]
        }

        let subscriptionPlanAddResp = await SubscriptionPlans.subscriptionPlanAdd(this, this.vmSubscriptionPlanFormData)
        if (subscriptionPlanAddResp.resp_status) {
          this.$emit("subscriptionPlanAdded", subscriptionPlanAddResp.resp_data)
        }

        await ApiResponse.responseMessageDisplay(this, subscriptionPlanAddResp)
        if (subscriptionPlanAddResp && !subscriptionPlanAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseSubscriptionPlanAddModal", subscriptionPlanAddResp.resp_data, this.planExists)
        }

        this.$refs.subsPlanForm.reset()
        this.vmSubscriptionPlanFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at subscriptionPlanAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * setModuleChipStyle
     */
    setModuleChipStyle (active) {
      if (active) {
        return {
          "color": "#FFFFFF",
          "border-color": "#51B5FD",
          "background-color": "#51B5FD"
        }
      }

      return {
        "color": "",
        "border-color": ""
      }
    },
    /**
     * selectModule
     */
    selectModule (module) {
      /*
      if (this.propModuleName) {
        // If u return from here the module will not get set. So test before u enable return
        return
      }
      */

      if (!this.selectedModuleObjList) {
        this.selectedModuleObjList = {}
      }

      if (this.selectedModuleObjList[module.id]) {
        this.$delete(this.selectedModuleObjList, module.id)
      }
      else {
        this.$set(this.selectedModuleObjList, module.id, module)
      }
    }
  }
}
</script>
<style>
  .textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
